/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="14.4"
        height="19"
        viewBox="0 0 14.4 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M12.38 16.92h2V4.63L9.77.04H2.05v2.07H-.02V19h12.38ZM10.04 1.7l2.64 2.63h-2.64Zm-7-.7h6v4.34h4.36v10.58H3.08Zm-1 2.08v13.85h9.3V18H1V3.08Zm6.31 9.94v1h-4v-1Zm3.67-2.89v1H4.38v-1Zm0-2.9v1H4.38v-1Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'TwoPagesFoldedCornerIcon';

export default Icon;
